const initialState = {
    Authenticated: false,
    users: {},
    token: '',
    insuranceCode: '',
    fullName: '',
    roles: [],
    phoneNumber: '',
    expiration: '',
    profilePhoto: '',

}

function redoxStorage(state = initialState, action) {
    let nextState

    switch (action.type) {
        case 'LOGIN':
            nextState = {
                ...state,
                Authenticated: true,
                token: action.token,
                expirationTime: action.expiration,

            }

            console.log('LOGIN state')
            console.log('current',initialState)
            console.log('next',nextState)

            return nextState || state

        case 'USER':
            nextState = {
                ...state,
                users: action.value,

            }

            return nextState || state

        case 'LOGIN_APP':
            nextState = {
                ...state,
                token: action.token,
                expirationTime: action.expiration,
            }

            return nextState || state

        case 'SET_CLIENT_DETAILS':
            return {
                ...state,
                users: {
                    ...state.users,
                    clientDetails: action.value
                }

            };

        case 'UPDATE_PROFILE_PICTURE':
            nextState = {
                ...state,
                users: {
                    ...state.users,
                    profilePhoto: action.value,
                },
            };
            return nextState || state;

        case 'UPDATE_USER_DATA':
            nextState = {
                ...state,
                users: {
                    ...state.users,
                    ...action.value,
                },
            };
            return nextState || state;

        case 'LOGOUT':
            return initialState



        default:
            return state
    }
}

export default redoxStorage
